import React, { Component } from 'react';
import {Row,Col,Form} from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';
import LocationSearchInput from '../../commons/helpers/googleLocationSearch';
import { LBL_LOCATION, LBL_LOC_GET_GOOGLE, LBL_TYPE_ADDRESS_GOOGLE, LBL_TYPE_A_LOCATION, LBL_VENUE_PROFILE, LBL_STREET_1, LBL_STREET_2,  LBL_CITY, LBL_STATE, LBL_COUNTRY, LBL_POST_CODE, LBL_SAVE } from '../../../configs/labelConfigs'; 
import {DISABLE_LOC_DET_EDIT} from '../../../configs/staticConfigs'; 


class Address extends Component {
    
    renderTooltip(name,props) {
        return (
          <Tooltip id={name}  style={{
            opacity: 0.4,
          }} {...props} >
            {name}
          </Tooltip>
        );
    }

    onGetGoogleLocClick = (e) =>{
        this.typeahead.clear()
        this.props.onGetGoogleLoc(e); 
    }
    
    render(){

        const { affiliateData, formErrors, locations} = this.props; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;

        // let disableEditAddress = (!DISABLE_LOC_DET_EDIT && affiliateData.affiliateAddress.googleLocation && affiliateData.affiliateAddress.googleLocation.length>0 && affiliateData.affiliateAddress.noLocationFound) ? false : true; 
        let disableEditAddress = (!DISABLE_LOC_DET_EDIT && affiliateData.affiliateAddress.googleLocation && affiliateData.affiliateAddress.googleLocation.length>0 && affiliateData.affiliateAddress.noLocationFound) ? false : false; 

        return(
            <Form onSubmit={e => this.props.updateFormData(e)}>
                <Form.Group>
                    <div className="box">
                        <div className="tab-head">
                            <h6>Address {(companyName) && <span>{' - '+companyName}</span>} </h6>
                        </div>
                        <div className="box-content">
                            <Row> 
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{LBL_LOCATION}</label>
                                    </div>
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="custom-checkbox">
                                            <input type="checkbox" id="noLocationFound" name="noLocationFound"  onChange={this.onGetGoogleLocClick} checked={affiliateData.affiliateAddress.noLocationFound} />
                                            <label className="checkbox" htmlFor="noLocationFound"></label>
                                            <label className="labeltext" htmlFor="noLocationFound">{LBL_LOC_GET_GOOGLE}
                                                <sup>
                                                <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderTooltip(LBL_TYPE_ADDRESS_GOOGLE)}
                                                >
                                                <button type="button" className="tootltip-btn">
                                                <i className="las la-question-circle"></i>
                                                </button>
                                                </OverlayTrigger>
                                                </sup>
                                            </label>
                                        </div>
                                    </div>
                                </div>                 
                                <div className="col-md-12">                           
                                    <div className="form-group">
                                        <div className={affiliateData.affiliateAddress.noLocationFound?'hide':'text-input'} >
                                            <AsyncTypeahead
                                                isLoading={false}
                                                name="location" 
                                                id="locationSearch"
                                                minLength={3}
                                                labelKey="location"
                                                onChange={selected => this.props.onSelectLocation(selected)}
                                                options={locations}
                                                placeholder={LBL_TYPE_A_LOCATION}
                                                onSearch={this.props.onsearchLocation}
                                                searchText="Searching"
                                                promptText={LBL_TYPE_A_LOCATION}
                                                disabled={this.props.disableLocationSearch}
                                                ref={ref => (this.typeahead = ref)}
                                            />  
                                        </div>
                                        <div className={affiliateData.affiliateAddress.noLocationFound?'text-input':'hide'} >
                                            <LocationSearchInput name="googleLocation" googleLocSelect={this.props.googleLocSelect} disabled={this.props.disableLocationSearch} />
                                        </div>  
                                    </div>
                                </div>
                            </Row>

                                
                                {/* 
                                <Row><Col md={6}>
                                    <div className="form-group">
                                        <label>Location</label>                                       
                                        <div className="text-input">
                                            <AsyncTypeahead
                                                isLoading={false}
                                                name="location" 
                                                id="locationSearch"
                                                minLength={3}
                                                labelKey="location"
                                                onChange={selected => this.props.onSelectLocation(selected)}
                                                options={locations}
                                                placeholder="Type a location..."
                                                onSearch={this.props.onsearchLocation}
                                                // selected={selected}
                                            />
                                        </div>
                                    </div>
                                </Col> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>Couldn't find the location? Get it from Google<sup>
                                                <button type="button" className="tootltip-btn"
                                                    data-toggle="tooltip" data-placement="top" title=""
                                                    data-original-title="Type address to get the location from google map">
                                                    <i className="las la-question-circle"></i>
                                                </button></sup> </label>
                                        <div className="text-input"><input type="text" placeholder=" " name="googleLocation" onChange={this.props.onHandleChange}/>
                                        </div>
                                    </div>
                                </Col> </Row> */}
                            
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VENUE_PROFILE}</label>
                                        <div className={disableEditAddress?"text-input text-optional":"text-input"}>
                                            <input type="text" placeholder={LBL_VENUE_PROFILE} name="venue" onChange={this.props.onHandleChange} value={affiliateData.affiliateAddress.venue || ''} maxLength={125}/>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">&nbsp;</div>
                                </Col>
                            </Row>

                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STREET_1}</label>
                                        <div className={disableEditAddress?"text-input text-optional":"text-input"}><input type="text" name="streetOne" onChange={this.props.onHandleChange}  value={affiliateData.affiliateAddress.streetOne || ''} maxLength={50} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STREET_2}</label>
                                        <div className={disableEditAddress?"text-input text-optional":"text-input"}><input type="text" name="streetTwo" onChange={this.props.onHandleChange}  value={affiliateData.affiliateAddress.streetTwo || ''} maxLength={50} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_CITY}</label>
                                        <div className={disableEditAddress?"text-input text-optional":"text-input"}><input type="text" name="city" onChange={this.props.onHandleChange} className={formErrors.city.length >0 ? "input-error" : ''} value={affiliateData.affiliateAddress.city || ''} maxLength={50} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_STATE}</label>
                                        <div className={disableEditAddress?"text-input text-optional":"text-input"}><input type="text" name="state" onChange={this.props.onHandleChange} className={formErrors.state.length >0 ? "input-error" : ''} value={affiliateData.affiliateAddress.state || ''} maxLength={50} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                            </Row>
                            
                            <Row>  
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_COUNTRY}</label>
                                        <div className="text-input text-optional"><input type="text" name="country" onChange={this.props.onHandleChange} className={formErrors.country.length >0 ? "input-error" : ''} value={affiliateData.affiliateAddress.country || ''} maxLength={50} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_POST_CODE}</label>
                                        <div className="text-input text-optional"><input type="text" name="postcode" onChange={this.props.onHandleChange} className={formErrors.postcode.length >0 ? "input-error" : ''} value={affiliateData.affiliateAddress.postcode || ''} maxLength={10} disabled={disableEditAddress} /></div>
                                    </div>
                                </Col>
                            </Row>                       
                            <div className="clearfix">
                                <button type="submit" className="btn btn-primary float-right">{LBL_SAVE}</button>
                            </div>
                        </div>
                    </div>
                </Form.Group>
            </Form>
        )
    }

}
export default Address;